export const NAV_LINKS = [
  {
    href: "/",
    label: "Scripts",
  },
  {
    href: "/scripts/new",
    label: "Upload",
  },
  {
    href: "/trending",
    label: "Trending",
  },
  {
    href: "/exploits",
    label: "Exploits",
  },
  {
    href: "/favorites",
    label: "Favorites",
  },
];
